import { call, takeLatest } from 'redux-saga/effects';

import * as constants from './home.constants';
import * as types from './home.types';
import * as services from './home.saga-services';

function* invokeInitialHomePage(action: types.IInitialHomePage) {
  yield call(services.initialHomePage);
}

function* invokeInitialBoardsHomePage(action: types.IInitialBoardsForMeeting) {
  yield call(services.initialBoardsHomePage, action.payload.meetingId);
}

export function* watchHomePageSaga() {
  yield takeLatest(constants.INITIAL_HOME_PAGE, invokeInitialHomePage);
  yield takeLatest(constants.INITIAL_BOARDS_FOR_MEETING, invokeInitialBoardsHomePage);
}
